import {
  GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT,
  GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_OK,
  GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_ERR,
  DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_CLEANUP,

  APPLY_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS,
  CLEAR_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS,
} from "./actionTypes";

/********** DATATABLE **********/

export const getSubscriptionCancellationRequestsDt = params => ({
  type: GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT,
  payload: { params },
});

export const getSubscriptionCancellationRequestsDtOk = response => ({
  type: GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_OK,
  payload: { response },
});

export const getSubscriptionCancellationRequestsDtErr = error => ({
  type: GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_ERR,
  payload: { error },
});

export const doSubscriptionCancellationRequestsDtCleanup = () => ({
  type: DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_CLEANUP,
});

/********** DATATABLE FILTERS **********/

export const applySubscriptionCancellationRequestsDtFilters = filters => ({
  type: APPLY_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS,
  payload: { filters },
});

export const clearSubscriptionCancellationRequestsDtFilters = () => ({
  type: CLEAR_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS,
});